import "../styles/PageToolbarSearchFilter.css";

function IconFilter() {
  return (
    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  );
}

export default function FilterTriggerButton({
  activeCount = 0,
  onClick,
  onClear,
  title = "Filters",
  label = "Filter",
  className = "",
}) {
  const active = activeCount > 0;
  return (
    <button
      type="button"
      className={`mv2-filter-btn${active ? " mv2-filter-btn--active" : ""}${className ? ` ${className}` : ""}`}
      title={title}
      onClick={onClick}
    >
      <IconFilter />
      {label}
      {active && <span className="mv2-filter-btn-count">: {activeCount}</span>}
      {active && (
        <span
          className="mv2-filter-btn-clear"
          role="button"
          tabIndex={0}
          title="Clear all filters"
          onClick={(e) => {
            e.stopPropagation();
            onClear?.();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              onClear?.();
            }
          }}
        >
          ×
        </span>
      )}
    </button>
  );
}
